import {
  CallToAction,
  Iframe,
  Media,
  ResponsiveImage,
  Table,
  TagFragment,
  VideoExternal,
  Video,
  SectionContact,
  SectionHero,
  SectionLogos,
  SectionStructuredText,
  SectionLead,
  SectionStats,
  SectionHeroAbout,
  SectionServices,
  SectionBigLead,
  SectionFeaturedProjects,
  SectionAboutImage,
  SectionThumbnails,
  SectionOverview,
  SectionContentList,
  SectionTitle,
  SectionPush,
  SectionAnchor
} from '~/graphql/fragments'

export const queryIndex = /* GraphQL */ `
  ${CallToAction}
  ${Iframe}
  ${Media}
  ${ResponsiveImage}
  ${Table}
  ${TagFragment}
  ${VideoExternal}
  ${Video}

  ${SectionContact}
  ${SectionHero}
  ${SectionLogos}
  ${SectionStructuredText}
  ${SectionLead}
  ${SectionStats}
  ${SectionHeroAbout}
  ${SectionServices}
  ${SectionBigLead}
  ${SectionFeaturedProjects}
  ${SectionAboutImage}
  ${SectionThumbnails}
  ${SectionOverview}
  ${SectionContentList}
  ${SectionTitle}
  ${SectionPush}
  ${SectionAnchor}

  query Index($locale: SiteLocale) {
    index(locale: $locale) {
      _allPublishTranslationLocales {
        value
        locale
      }
      _seoMetaTags {
        ...TagFragment
      }
      _modelApiKey
      title
      main {
        ... on RecordInterface {
          id
          __typename
        }
        ...SectionContact
        ...SectionHero
        ...SectionLogos
        ...SectionStructuredText
        ...SectionLead
        ...SectionStats
        ...SectionHeroAbout
        ...SectionServices
        ...SectionBigLead
        ...SectionFeaturedProjects
        ...SectionAboutImage
        ...SectionThumbnails
        ...SectionOverview
        ...SectionContentList
        ...SectionTitle
        ...SectionPush
        ...SectionAnchor
      }
      publishTranslation
      seoMetadata {
        noIndex
      }
    }
  }
`
